import {ApiPlant, InventoryStatus} from '../../models/Model';
import {IPlant} from '../../models/Products';

const transformApiPlantToPlant = (apiPlant: ApiPlant, plantBaseUrl: string): IPlant => ({
    name: apiPlant.plant.name,
    shortName: apiPlant.plant.short_name,
    id: apiPlant.plant.id,
    imageId: apiPlant.plant.image_id,
    imageUrl: `${plantBaseUrl}/${apiPlant.plant.image_id}.png`,
    daysToGermination: apiPlant.plant.life_cycle.days_to_germination,
    daysToHarvest: apiPlant.plant.life_cycle.days_to_harvest,
    daysToEndOfLife: apiPlant.plant.life_cycle.days_to_end_of_life,
    archived: apiPlant.inventory.status === InventoryStatus.Disabled,
    outOfStock: apiPlant.inventory.status === InventoryStatus.OutOfStock,
});

export default transformApiPlantToPlant;
